<script lang="ts">
  import { ResponsiveVars } from '@twist/core';
  import { cx } from '@emotion/css';

  import { key as navbarModalKey } from '../NavbarModal.svelte';
  import { modals } from '$lib/stores/modals';
  import Menu from '$components/Icons/Menu.svelte';

  export let color: 'white' | 'black' = 'white';

  let button: HTMLButtonElement;

  const responsiveVars = new ResponsiveVars()
    .addFluid('toggle-p', [
      ['min', 6],
      ['sm', 'lg', 6, 12],
      ['lg', 12]
    ])
    .addFluid('icon-size', [
      ['min', 24],
      ['sm', 'lg', 24, 48],
      ['lg', 12]
    ])
    .toCSS();
</script>

<button
  bind:this={button}
  class={cx(responsiveVars, 'modal-toggle')}
  class:color-black={color === 'black'}
  aria-label="Open Navigation Menu"
  on:click={() => modals.open(navbarModalKey, button)}
>
  <div class="icon">
    <Menu />
  </div>
</button>

<style lang="scss">
  .modal-toggle {
    cursor: pointer;
    display: flex;

    border: none;

    border-radius: 1000px;
    padding: var(--toggle-p);

    outline: none;
    color: #fff;
    background-color: transparent;

    &:hover,
    &:focus-visible {
      color: #000;
      background-color: #fff;
    }

    &.color-black {
      color: #000;

      &:hover,
      &:focus-visible {
        color: #fff;
        background-color: #000;
      }
    }
  }

  .icon {
    display: flex;
    justify-content: center;
    height: var(--icon-size);
    width: var(--icon-size);
  }
</style>
